const o = "Movistar", I = "O2", c = "O2-classic", s = "Vivo", S = "Telefonica", t = "Blau";
export { t as BLAU_SKIN, o as MOVISTAR_SKIN, c as O2_CLASSIC_SKIN, I as O2_SKIN, S as TELEFONICA_SKIN, s as VIVO_SKIN };
